import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { IEDate } from '@appbase/util';
import { openReserveResourceDate } from '@reserve/popup-handler';
import { mapGetters } from 'vuex';
import * as types from '@reserve/store/types'

import WeekItem from './WeekItem.vue';
import reserveHelper from '../../reserve-helper'


@Component({
    components: {
        WeekItem
    },

    computed: mapGetters({
        curCompany: types.CALENDAR_COMPANY,
        curCategory: types.CALENDAR_CATEGORY,
        selectedResources: types.SELECTED_RESOURCE_LIST,
    })
})
export default class WeekRowItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.DateItem;

    curCompany!: string | null;
    curCategory!: 'FAVORITE' | 'EWS' | 'DB';

    eventsModel: reserve.CalendarItem[] = [];
    selectedResources!: reserve.ResourceItemBase[];

    @Watch('item')
    itemChanged(newVal: reserve.DateItem) {
        if(newVal.events) {
            this.eventsModel = newVal.events.filter(e => e.id !== 'null');         
        }
    }

    created() {
        if(this.item != null)
            this.itemChanged(this.item);
    }

    onSelectDblClick() {
        if(this.curCompany == null)
            return;

        let resource: string | undefined;
        let selection = this.selectedResources.filter(r => !reserveHelper.isHeaderType(r.resourceType));

        if(selection.length == 1) {            
            resource = selection[0].address;      
        }

        var target = IEDate(this.item.date);
        openReserveResourceDate(this.curCompany, target, this.curCategory, resource);
    }
}